import { render, staticRenderFns } from "./ChangeLeadersPanel.vue?vue&type=template&id=acb3b048&scoped=true&"
import script from "./ChangeLeadersPanel.vue?vue&type=script&lang=js&"
export * from "./ChangeLeadersPanel.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLeadersPanel.vue?vue&type=style&index=0&id=acb3b048&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acb3b048",
  null
  
)

export default component.exports